var map = {
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts",
		"auth.module",
		"common"
	],
	"./beacons/beacons.module": [
		"./src/app/beacons/beacons.module.ts",
		"beacons.module"
	],
	"./call-manage/call-manage.module": [
		"./src/app/call-manage/call-manage.module.ts",
		"call-manage.module"
	],
	"./caregivers/caregivers.module": [
		"./src/app/caregivers/caregivers.module.ts",
		"caregivers.module",
		"common"
	],
	"./help/help.module": [
		"./src/app/help/help.module.ts",
		"help.module"
	],
	"./indiv-client/indiv-client.module": [
		"./src/app/indiv-client/indiv-client.module.ts",
		"indiv-client.module",
		"common"
	],
	"./my-dashboard/my-dashboard.module": [
		"./src/app/my-dashboard/my-dashboard.module.ts",
		"my-dashboard.module"
	],
	"./projects/projects.module": [
		"./src/app/projects/projects.module.ts",
		"projects.module"
	],
	"./settings/settings.module": [
		"./src/app/settings/settings.module.ts",
		"settings.module"
	],
	"./start/start.module": [
		"./src/app/start/start.module.ts",
		"start.module",
		"common"
	],
	"./technical-support/technical-support.module": [
		"./src/app/technical-support/technical-support.module.ts",
		"technical-support.module"
	],
	"./user-history/user-history.module": [
		"./src/app/user-history/user-history.module.ts",
		"user-history.module"
	],
	"./users/users.module": [
		"./src/app/users/users.module.ts",
		"users.module",
		"common"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main